import { some } from "../common/constants";
import { stringify } from "query-string";
import { mappedFilter } from "../common/utils";
export const development: boolean =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";

const getBaseUrl =
  window.apiConfig?.domainApi ?? process.env.REACT_APP_DOMAIN_API;
const getAuthUrl =
  window.apiConfig?.domainAuth ?? process.env.REACT_APP_DOMAIN_AUTH;

export const API_PATHS = {
  auth: {
    validateToken: `${getBaseUrl}/api/auth/me`,
    login: (params: some) =>
      `${getAuthUrl}/api/generate-token?${stringify(
        mappedFilter(params || {}),
        {
          arrayFormat: "comma",
          skipEmptyString: true,
          skipNull: true,
        }
      )}`,
    signUp: `${getBaseUrl}/api/auth/signup`,
    changePassword: `${getAuthUrl}/api/change_password`,
    resetToken: `${getAuthUrl}/api/auth/resetToken`,
    getUserInfo: `${getAuthUrl}/api/user/get-user-profile`,
    edit: (username: string) => `${getBaseUrl}/api/user/edit/${username}`,
  },
  upload: {
    uploadSingleFile: `${getBaseUrl}/api/file/upload`,
    uploadMultiFile: `${getBaseUrl}/api/file/upload-multiple`,
    getFile: (filename: string) => `${getBaseUrl}/api/file/files/${filename}`,
    getFileZip: `${getBaseUrl}/api/file/files/download-zip`,
  },
  monitoring: {
    index: (params: some) =>
      `${getBaseUrl}/api/monitoring?${stringify(mappedFilter(params))}`,
    indexForDataLedLatest: () =>
      `${getBaseUrl}/api/monitoring/data-led-lastest`,
    indexForDataLedDay: () => `${getBaseUrl}/api/monitoring/data-led-30-day`,
    indexForTime: () => `${getBaseUrl}/api/monitoring/time-text`,
    timeSwitch : () => `${getBaseUrl}/api/monitoring/time-switch`,
  },
  nreType: {
    index: (params?: some) =>
      `${getBaseUrl}/api/nre-type?${stringify(mappedFilter(params || {}), {
        arrayFormat: "comma",
        skipEmptyString: true,
        skipNull: true,
      })}`,
    indexForWater: (params?: some) =>
      `${getBaseUrl}/api/nre-type/for-water-quality?${stringify(
        mappedFilter(params || {}),
        {
          arrayFormat: "comma",
          skipEmptyString: true,
          skipNull: true,
        }
      )}`,
    update: (id: string) => `${getBaseUrl}/api/nre-type/${id}`,
    create: `${getBaseUrl}/api/nre-type`,
  },
  user: {
    index: (params?: some) =>
      `${getAuthUrl}/api/user/get-users?${stringify(
        mappedFilter(params || {}),
        {
          arrayFormat: "comma",
          skipEmptyString: true,
          skipNull: true,
        }
      )}`,
    create: `${getAuthUrl}/api/user/create-user`,
    get: `${getAuthUrl}/api/user/get-user-profile`,
    delete: `${getAuthUrl}/api/user/delete-user`,
    getRole: `${getAuthUrl}/api/user/get-users-in-role`,
    changePassword: `${getAuthUrl}/api/change_password_by_admin`,
  },
  role: {
    getAllRole: (params?: some) =>
      `${getAuthUrl}/api/role/get-all-role?${stringify(
        mappedFilter(params || {}),
        {
          arrayFormat: "comma",
          skipEmptyString: true,
          skipNull: true,
        }
      )}`,
    getDetail: (params?: some) =>
      `${getAuthUrl}/api/role/get-role-detail?${stringify(
        mappedFilter(params || {}),
        {
          arrayFormat: "comma",
          skipEmptyString: true,
          skipNull: true,
        }
      )}`,
    create: `${getAuthUrl}/api/role/create-role`,
    update: `${getAuthUrl}/api/role/update-role`,
    addRight: `${getAuthUrl}/api/role/add-right`,
    deleteRole: `${getAuthUrl}/api/role/delete-role`,

    getRight: `${getAuthUrl}/api/right/get-rights`,
    userInRole: (params?: some) =>
      `${getAuthUrl}/api/user/get-users-in-role?${stringify(
        mappedFilter(params || {}),
        {
          arrayFormat: "comma",
          skipEmptyString: true,
          skipNull: true,
        }
      )}`,
    addUser: `${getAuthUrl}/api/role/add-user`,
    removeUser: `${getAuthUrl}/api/role/remove-user`,
  },
  menu: {
    getAll: (params?: some) =>
      `${getAuthUrl}/api/menu/get-menu-by-app-id?${stringify(
        mappedFilter(params || {}),
        {
          arrayFormat: "comma",
          skipEmptyString: true,
          skipNull: true,
        }
      )}`,
    create: `${getAuthUrl}/api/menu/create-menu`,
    update: `${getAuthUrl}/api/menu/update-menu`,
    delete: `${getAuthUrl}/api/menu/delete-menu`,
  },
  job: {
    delete: `${getAuthUrl}/api/scheduler/delete-job`,
    getAll: `${getAuthUrl}/api/scheduler/get-all-job`,
    getDetail: `${getAuthUrl}/api/scheduler/get-job-detail`,
    getLog: (params?: some) =>
      `${getAuthUrl}/api/scheduler/get-scheduler-log?${stringify(
        mappedFilter(params || {}),
        {
          arrayFormat: "comma",
          skipEmptyString: true,
          skipNull: true,
        }
      )}`,
    pause: `${getAuthUrl}/api/scheduler/pause-job`,
    register: `${getAuthUrl}/api/scheduler/register-job`,
    resume: `${getAuthUrl}/api/scheduler/resume-job`,
    start: `${getAuthUrl}/api/scheduler/start-job-now`,
    unschedule: `${getAuthUrl}/api/scheduler/unschedule-job`,
    update: `${getAuthUrl}/api/scheduler/update-job`,
  },
};
